import React from 'react'
import "./ContactButton.css"
import Button from 'react-bootstrap/Button';

const ContactButton = () => {
  return (
    <div>
     <div className="counter-wrapper2">
        <div className="counter2">
            <h2 className='count2' >
            Whether you are looking for the finest PP woven fabric, dependable PP woven sack bags, Somnath polytex is here to meet your needs.
             </h2>
            {/* <p>Years of Experience</p> */}
            <Button > <a href="/Contact">Contact Us</a></Button>
        </div>
       
       
      </div>
    </div>
  )
}

export default ContactButton
